export default "Le Fonds de Décarbonation Industrie (plan France 2030) cofinance les projets de décarbonation des PME et ETI industrielles. Montants, critères d'éligibilité et accompagnement.";
